
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TreatmentPlanApi } from '../api/treatmentplan.api';
import { switchMap, map } from 'rxjs/operators';

import { TreatmentPlanData, TreatmentPlan } from '../../../interfaces/masters/treatmentplan' ;
@Injectable()
export class TreatmentPlanService extends TreatmentPlanData {

    constructor(private api: TreatmentPlanApi) {
      super();
    }
  
  
    list(url: string): Observable<TreatmentPlan[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<TreatmentPlan>{
        return this.api.getById(url);
    }
  
    create(url: string, data:TreatmentPlan): Observable<TreatmentPlan[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:TreatmentPlan): Observable<TreatmentPlan> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  